import React, { useContext } from "react";
// import { Link } from "react-router-dom";
import styled from "styled-components"
import colors from "../../utils/style/colors.tsx";
import { Titre, Texte } from "../../utils/style/elements.tsx"
import ProjectList from "../../components/ProjectList/ProjectList.tsx";
import grosProjetsData from "../../datas/grosProjetsData";
import inspiData from "../../datas/inspiData";
import { LanguageContext } from "../../context/LanguageContext";
import bioTrad from "../../traductions/bio-trad.js";


const Main = styled.main``

const PresentationContainer = styled.div`
    margin-bottom: 80px;   

    @media (max-width: 768px) {
        margin-bottom: 40px;   
    } 
`

const StyledTitre = styled(Titre)`
    margin: 50px 0 20px;

    @media (max-width: 768px) {
        margin: 30px 0 15px;
    }
`

const ListeContainer = styled.div`
    margin-bottom: 50px;
`;


const LinkContainer = styled.div`
    width: 100%;
    display: flex;
    color: ${colors.red};
`;

const LinkUl = styled.ul`
    @media (max-width: 1150px) {
        padding-left: 20px;
    }
`;

const LinkLi = styled.li`
    margin-bottom: 5px;
`;

const LinkLien = styled.a`
    color: ${colors.red};
    text-decoration: none;
    font-size: 24px;
    word-break: break-all;

    &:hover {
        border-bottom: solid 2px ${colors.red};
    }

    @media (max-width: 1150px) {
        font-size: 20px;
    }

    @media (max-width: 768px) {
        font-size: 16px;
    }
`;



function Bio() {

    const { language } = useContext(LanguageContext);
    
    return (
        <Main>
            <PresentationContainer>
                <StyledTitre>Alexandre K.</StyledTitre>
                <Texte>
                    {bioTrad[language].presentation}
                </Texte>
            </PresentationContainer>

            <PresentationContainer>
                <Titre>{bioTrad[language].passionTitre}</Titre>
                <Texte>
                    {bioTrad[language].passionTexte}
                </Texte>

            </PresentationContainer>

            <PresentationContainer>
                <Titre>Liens des jeux</Titre>
                <LinkContainer>
                    <LinkUl>
                        <LinkLi >
                            <LinkLien href="https://alexandre-kotowicz.itch.io/crows" target="_blank">
                                Crow's Eulogy : https://alexandre-kotowicz.itch.io/crows
                            </LinkLien>
                        </LinkLi>
                        <LinkLi >
                            <LinkLien href="https://alexandre-kotowicz.com/to-the-peak" target="_blank">
                                To The Peak : https://alexandre-kotowicz.com/to-the-peak
                            </LinkLien>
                        </LinkLi>
                        <LinkLi >
                            <LinkLien href="https://alexandre-kotowicz.itch.io/every-breaking-wave" target="_blank">
                                Every Breaking Wave : https://alexandre-kotowicz.itch.io/every-breaking-wave
                            </LinkLien>
                        </LinkLi>
                    </LinkUl>
                </LinkContainer>
            </PresentationContainer>

            <PresentationContainer>
                <ListeContainer>
                    <Titre>Mes plus gros projets</Titre>
                    <ProjectList projects={grosProjetsData} centered={true} />
                </ListeContainer>
            </PresentationContainer>

            <PresentationContainer>
                <ListeContainer>
                    <Titre>Mes inspirations</Titre>
                    <ProjectList projects={inspiData} centered={true} />
                </ListeContainer>
            </PresentationContainer>

            
        </Main>
    )
}

export default Bio
